import React, { useEffect, useState } from 'react';
// import { ReactComponent as Delete } from 'style/imgs/icons/delete-icon.svg';
import { ISigninResource } from 'types';
import styles from './styles.module.scss';

interface Props {
  index: number;
  resource: ISigninResource;
  saved: boolean;
  onDelete(id: number): void;
  onChange(id: number, value: string): void;
  onTested(onTested: ISigninResource): void;
}

const SigninListItem = React.forwardRef<HTMLInputElement, Props>(
  ({ resource, onChange, onTested, index, saved }) => {
    const { url: link, id } = resource;

    const [readOnly, setReadOnly] = useState(true);

    const [inputValue, setInputValue] = useState(link);
    useEffect(() => {
      setInputValue(link);
    }, [link]);

    const handleFocus = () => {
      setReadOnly(false);
    };

    const handleBlur = () => {
      setReadOnly(true);
      onChange(id, inputValue);
    };

    const handleChange: React.ChangeEventHandler<HTMLInputElement> = ({
      target: { value },
    }) => {
      setInputValue(value);
    };

    return (
      <li className={styles.root}>
        <span className={styles.number}>{index + 1}.</span>
        <div className={styles.inputContainer}>
          <span className={styles.placeholder}>Website</span>
          <input
            type="text"
            className={styles.input}
            value={inputValue || ''}
            readOnly={readOnly}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
            disabled
          />

          {/* <button
            className={styles.delete}
            type="button"
            onClick={() => onDelete(id)}
          >
            <Delete />
          </button> */}
        </div>
        {resource?.tested ? (
          <button
            className={`${styles.signinBtn} ${styles.tested}`}
            type="button"
          >
            Tested
          </button>
        ) : (
          <button
            className={`${styles.signinBtn} ${!saved && styles.disabled}`}
            type="button"
            onClick={() => onTested(resource)}
          >
            Test link
          </button>
        )}
      </li>
    );
  }
);

export default SigninListItem;
